var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutlook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 1.625H9.75C8.85254 1.625 8.125 2.35254 8.125 3.25V22.75C8.125 23.6475 8.85254 24.375 9.75 24.375H22.75C23.6475 24.375 24.375 23.6475 24.375 22.75V3.25C24.375 2.35254 23.6475 1.625 22.75 1.625Z",
    fill: "#1066B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 1.625H9.75C8.85254 1.625 8.125 2.35254 8.125 3.25V22.75C8.125 23.6475 8.85254 24.375 9.75 24.375H22.75C23.6475 24.375 24.375 23.6475 24.375 22.75V3.25C24.375 2.35254 23.6475 1.625 22.75 1.625Z",
    fill: "url(#paint0_linear_1699_7327)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.0625H8.125V12.1875H16.25V4.0625Z",
    fill: "#32A9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 12.1875H8.125V20.3125H16.25V12.1875Z",
    fill: "#167EB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 12.1875H16.25V20.3125H24.375V12.1875Z",
    fill: "#32A9E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 4.0625H16.25V12.1875H24.375V4.0625Z",
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1699_7327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 11,
    width: 20,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.375H24.375C25.2725 11.375 26 12.1025 26 13V22.75C26 23.6475 25.2725 24.375 24.375 24.375H8.125C7.22754 24.375 6.5 23.6475 6.5 22.75V11.375Z",
    fill: "url(#paint1_linear_1699_7327)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1699_7327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 11.375V14.625H24.375V11.375H26Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 24.375V13L5.6875 24.375H26Z",
    fill: "url(#paint2_linear_1699_7327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 24.375V13L26.8125 24.375H6.5Z",
    fill: "url(#paint3_linear_1699_7327)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.75C6.5 8.40377 7.59131 7.3125 8.9375 7.3125H13.8125C15.1587 7.3125 16.25 8.40377 16.25 9.75V19.5C16.25 20.8462 15.1587 21.9375 13.8125 21.9375H6.5V9.75Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.6875H1.625C0.727537 5.6875 0 6.41504 0 7.3125V18.6875C0 19.585 0.727537 20.3125 1.625 20.3125H13C13.8975 20.3125 14.625 19.585 14.625 18.6875V7.3125C14.625 6.41504 13.8975 5.6875 13 5.6875Z",
    fill: "url(#paint4_linear_1699_7327)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 13.0563V12.9212C11.375 10.5805 9.69085 8.9375 7.32535 8.9375C4.947 8.9375 3.25 10.5918 3.25 12.9437V13.0788C3.25 15.4195 4.93413 17.0625 7.3125 17.0625C9.67801 17.0625 11.375 15.4082 11.375 13.0563ZM9.45945 13.0788C9.45945 14.6317 8.58528 15.5658 7.32535 15.5658C6.06547 15.5658 5.1784 14.6092 5.1784 13.0563V12.9212C5.1784 11.3683 6.05261 10.4342 7.3125 10.4342C8.55953 10.4342 9.45945 11.3908 9.45945 12.9437V13.0788Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1699_7327",
    x1: 8.125,
    y1: 13,
    x2: 24.375,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1699_7327",
    x1: 6.5,
    y1: 21.75,
    x2: 26,
    y2: 21.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1699_7327",
    x1: 26,
    y1: 18.6875,
    x2: 6.5,
    y2: 18.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1699_7327",
    x1: 6.5,
    y1: 18.6875,
    x2: 26,
    y2: 18.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1699_7327",
    x1: 0,
    y1: 13,
    x2: 14.625,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutlook);
export default __webpack_public_path__ + "static/media/icon_outlook.e8ca3bba532ad61a6b27c76732f83623.svg";
export { ForwardRef as ReactComponent };